import React from "react";
import { TextInput, NumberInput } from "@mantine/core";
import { DatePicker, TimeInput } from "@mantine/dates";
import OptionList from "./OptionList";

const SurveyQuestion = ({
  question,
  groupIndex,
  questionIndex,
  onAnswerChange,
}: any) => {
  const type = question.survey_Question_Type_Id;

  return (
    <div className="border p-4 rounded bg-white shadow-sm">
      {/* Question */}
      <div className="mb-2">
        <p className="font-semibold text-gray-800">
          {question?.survey_Question_Title}
        </p>

        {/* Description */}
        {question?.survey_Question_Description && (
          <p className="text-sm text-gray-600 leading-snug">
            {question?.survey_Question_Description}
          </p>
        )}

        {/* Instruction */}
        {question?.survey_Question_Instructions && (
          <div className="flex items-start gap-1 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded-md w-fit">
            <span>💡</span>
            <span>{question?.survey_Question_Instructions}</span>
          </div>
        )}
      </div>

      {/* Input Area */}
      <div className="flex flex-wrap gap-3 items-start md:items-center">
        {/* TEXT */}
        {type === 2 && (
          <TextInput
            placeholder={question.survey_Question_Description}
            value={question.selectedValue}
            onChange={(e) =>
              onAnswerChange(
                groupIndex,
                questionIndex,
                undefined,
                e.currentTarget.value,
              )
            }
            className="w-full"
            maxLength={question?.survey_Character_Limit || 100}
          />
        )}

        {/* NUMBER */}
        {type === 3 && (
          <NumberInput
            hideControls
            placeholder={question.survey_Question_Description}
            value={question.selectedValue}
            onChange={(val) =>
              onAnswerChange(
                groupIndex,
                questionIndex,
                undefined,
                String(val || ""),
              )
            }
            className="w-full"
            min={0}
          />
        )}

        {/* DATE */}
        {type === 5 && (
          <DatePicker
            placeholder="Select date"
            value={question.selectedValue || null}
            onChange={(val: any) =>
              onAnswerChange(
                groupIndex,
                questionIndex,
                undefined,
                val ? val.toISOString() : "",
              )
            }
            className="w-full"
          />
        )}

        {/* TIME */}
        {type === 7 && (
          <TimeInput
            value={question.selectedValue}
            onChange={(e) =>
              onAnswerChange(groupIndex, questionIndex, undefined, e)
            }
            className="w-full"
          />
        )}

        {/* OPTIONS */}
        {(type === 1 || type === 4) && (
          <div className="w-full">
            <OptionList
              options={question.survey_Options_List}
              type={type}
              onSelect={(optIndex: number) =>
                onAnswerChange(groupIndex, questionIndex, optIndex)
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SurveyQuestion;
